﻿[<RequireQualifiedAccess>]
module SafeStack.Client.ListItem

let replaceById (id: 'a -> 'b) (value: 'a) (list: 'a list) =
    [
        for item in list do
            if id item <> id value then
                yield item
            else
                yield value
    ]

let modifyById (id: 'a -> 'b) idToReplace (replacer: 'a -> 'a) (list: 'a list) =
    [
        for item in list do
            if id item <> idToReplace then
                yield item
            else
                yield replacer item
    ]

let removeById (id: 'a -> 'b) itemId (list: 'a list) =
    [
        for item in list do
            if id item <> itemId then
                yield item
            else
                ()
    ]

///Dispatch msg to a model in a list of models and return the updated results, ensuring that the order is preserved
let dispatchMsgInList (itemIdToUpdate: 'ItemId) idGetter (items: 'Item list) updateFunc (defaultEffectOrMsg: 'effectOrMsg) (msg: 'Msg) = 
    //required to preserve the order
    let widgetsOrder = items |> List.mapi (fun i x -> idGetter x, i) |> Map

    let rec loop acc remaining = 
        match remaining with 
        | [] -> acc, defaultEffectOrMsg
        | h::tail ->
            if idGetter h = itemIdToUpdate then 
                let m, c = updateFunc msg h
                (m::acc) @ tail, c
            else loop (h::acc) tail

    let updatedItems, eff = loop [] items 
    updatedItems |> List.sortBy (idGetter >> (fun k -> widgetsOrder.[k])), eff     